import { useIsOrganizationReadOnly } from 'hooks/useIsOrganizationReadOnly';

import { maxNumClustersInFreePlan } from '../constants';

import { useTrial } from '@cast/shared-trial-ui';

type Props = {
  totalClusters?: number;
};

export const useHasLimitedFunctionality = ({ totalClusters }: Props) => {
  const accountReadOnly = useIsOrganizationReadOnly();
  const { isEligible, state } = useTrial();

  const displayPremiumFeaturesThreshold =
    isEligible && (totalClusters ?? 0) > maxNumClustersInFreePlan;

  // Disable filtering for free plan users if there are more than 5 clusters
  const hasLimitedFunctionality =
    displayPremiumFeaturesThreshold &&
    (state === 'post-trial' || accountReadOnly);

  return { hasLimitedFunctionality };
};
